export * from './SendPaperplaneDiagIcon';
export * from './SendPaperplaneDiagIcon16Light';
export * from './SendPaperplaneDiagIcon16Regular';
export * from './SendPaperplaneDiagIcon16Solid';
export * from './SendPaperplaneDiagIcon20Light';
export * from './SendPaperplaneDiagIcon20Regular';
export * from './SendPaperplaneDiagIcon20Solid';
export * from './SendPaperplaneDiagIcon24Regular';
export * from './SendPaperplaneDiagIcon24Solid';
export * from './SendPaperplaneDiagIcon32Regular';
export * from './SendPaperplaneDiagIcon64Regular';
